export default "__VITE_ASSET__CSec29Pm__"